import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const propTypes = {
  logos: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    href: PropTypes.string
  })),
  title: PropTypes.string
}

const defaultProps = {
  logos: [],
  title: 'Trusted by Industry Leaders'
}

const TrustLogoStrip = ({ logos, title }) => {
  return (
    <styles.Container>
      <styles.Content>
        {title && <styles.Title>{title}</styles.Title>}
        <styles.LogoWrapper>
          <styles.LogoTrack>
            {logos.map((logo, index) => (
              <styles.LogoItem key={index}>
                {logo.href ? (
                  <styles.LogoLink href={logo.href} target="_blank" rel="noopener noreferrer">
                    <styles.Logo src={logo.src} alt={logo.alt} />
                  </styles.LogoLink>
                ) : (
                  <styles.Logo src={logo.src} alt={logo.alt} />
                )}
              </styles.LogoItem>
            ))}
            {/* Duplicate logos for seamless scrolling on mobile */}
            {logos.map((logo, index) => (
              <styles.LogoItem key={`duplicate-${index}`} aria-hidden="true">
                {logo.href ? (
                  <styles.LogoLink href={logo.href} target="_blank" rel="noopener noreferrer">
                    <styles.Logo src={logo.src} alt={logo.alt} />
                  </styles.LogoLink>
                ) : (
                  <styles.Logo src={logo.src} alt={logo.alt} />
                )}
              </styles.LogoItem>
            ))}
          </styles.LogoTrack>
        </styles.LogoWrapper>
      </styles.Content>
    </styles.Container>
  )
}

TrustLogoStrip.propTypes = propTypes
TrustLogoStrip.defaultProps = defaultProps

export default TrustLogoStrip